<div class="agency-section"></div>
<div class="table-wrapper">
  <div class="table-header gap-4">
    <div class="align-items-center flex">
      <div>
        <button pButton pRipple type="button" [disabled]="loading"
                class="p-button-rounded p-button-text reload-btn" (click)="getAgencies()"></button>
      </div>
      <h2>Agency Management</h2>
      <div class="user-label">
        <img alt="user.svg" src="../../assets/images/agencyies_m.svg" />
        <span>{{ totalAgencies }}</span>
      </div>
    </div>

    <div class="align-items-center flex">
      <div class="p-inputgroup table-search-wrapper">
        <span class="p-inputgroup-addon"
          ><img alt="search.svg" src="../../assets/images/search.svg"
        /></span>
        <input
          (keyup)="searchAgencies()"
          [(ngModel)]="searchAgency"
          class="table-search-field"
          placeholder="Search agency by Name, Email, Phone"
          type="text"
        />
      </div>

      <div
        *ngIf="
          (currentUser.currentUserRole == agencyAdminUser
          || currentUser.currentUserRole == iohSuperAdmin
          || currentUser.currentUserRole == iohAdmin
          || currentUser.currentUserRole == companyAdmin) &&
          selectedAgenciesToExport.length
        "
        class="mr-3"
      >
        <div class="field mb-0">
          <div class="p-inputgroup table-calendar-wrapper">
            <span class="p-inputgroup-addon"
              ><img alt="calendar.svg" src="assets/images/calendar.svg"
            /></span>
            <p-calendar
              (onClear)="onCalendarClear()"
              (onSelect)="setDatesForExport()"
              [(ngModel)]="rangeDates"
              [readonlyInput]="true"
              class="w-full"
              dateFormat="{{ datePickerFormat }}"
              inputId="range"
              ngDefaultControl
              placeholder="{{ datePickerPlaceholder }}"
              selectionMode="range"
              [maxDate]="maxDate"
            ></p-calendar>
            <button
              (click)="onCalendarClear()"
              *ngIf="rangeDates != null"
              class="clearBtn"
            >
              <img alt="" src="assets/images/error.svg" />
            </button>
          </div>
        </div>
      </div>

      <div
        *ngIf="currentUser.currentUserRole == agencyAdminUser ||
         currentUser.currentUserRole == iohSuperAdmin ||
         currentUser.currentUserRole == iohAdmin ||
         currentUser.currentUserRole == companyAdmin"
        class="export-btn mr-3"
      >
        <!--|| !(rangeDates && rangeDates.length === 2 && rangeDates[0] && rangeDates[1])-->
        <div class="export-report">
          <p-button label="Generate Reports" [disabled]="!selectedAgenciesToExport.length "
                    ></p-button>
          <p-dropdown #reportDropdown [disabled]="!selectedAgenciesToExport.length " placeholder="Generate Reports"
                      [options]="exportReportValues" (onChange)="onGenerateReportSelect($event)"
                      (mouseenter)="selectedAgenciesToExport.length ? reportDropdown.show() : ''"
                      (mouseleave)="selectedAgenciesToExport.length ? reportDropdown.hide() : ''"
                      [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'" [panelStyle]="{ width: '210px'}"
                      ></p-dropdown>
        </div>
      </div>

      <p-button
        (click)="onAddAgencyClick()"
        *ngIf="currentUser.currentUserRole != agencyAdminUser"
        label="Add Agency"
        styleClass="button-sm add-icon"
      ></p-button>
    </div>
  </div>
  <p-table
    #dt
    [(selection)]="selectedAgenciesToExport"
    [rowHover]="true"
    [rowsPerPageOptions]="[10, 20, 30]"
    [rows]="10"
    [showCurrentPageReport]="true"
    [value]="agencies"
    dataKey="id"
    (onRowSelect)="onRowSelect()"
    (onRowUnselect)="onRowUnSelect($event)"
    (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
  >
    <ng-template pTemplate="header">
      <tr class="gc-table-filter">
        <th *ngIf="selectedRows.length !== 0 && (currentUser.currentUserRole == agencyAdminUser ||
        currentUser.currentUserRole == iohSuperAdmin ||
        currentUser.currentUserRole == iohAdmin ||
        currentUser.currentUserRole == companyAdmin)" id="tableHeaderCheckbox">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="w-4" id="agency" *ngIf="isRowVisible('Agency')">Agency</th>
        <th class="w-3" id="email" *ngIf="isRowVisible('Email')">Email</th>
        <th class="w-2" id="phone" *ngIf="isRowVisible('Phone')">Phone</th>
        <th class="w-10rem" id="level" *ngIf="isRowVisible('Level')">
          <div class="flex align-items-center gap-2">
            <span>Level</span>
            <div class="filterClass">
              <img class="w-16" *ngIf="!selectedAgencyLevel"
                   (click)="dropdown.show()" src="assets/images/filter-outline.svg">
              <img class="w-18" *ngIf="selectedAgencyLevel"
                   (click)="dropdown.show()" src="assets/images/filter-filled.svg">
              <p-dropdown
                #dropdown
                (onChange)="onChangeAgencyLevelFilter($event)"
                [(ngModel)]="selectedAgencyLevel"
                [autoDisplayFirst]="false"
                [options]="agencyLevelFilterOptions"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th class="w-10rem" id="status" *ngIf="isRowVisible('Status')">
          <div class="flex align-items-center gap-2">
            <span>Status</span>
            <div class="filterClass dd-align-right">
              <img class="w-16" *ngIf="!selectedAgencyStatus"
                   (click)="statusDropdown.show()" src="assets/images/filter-outline.svg">
              <img class="w-18" *ngIf="selectedAgencyStatus && selectedAgencyStatus !== 'ALL'"
                   (click)="statusDropdown.show()" src="assets/images/filter-filled.svg">
<!--               <img class="w-16" *ngIf="selectedAgencyStatus === 'ALL'" (click)="statusDropdown.show()" src="assets/images/filter-outline.svg" />-->
<!--              <img class="w-18" *ngIf="selectedAgencyStatus == false || selectedAgencyStatus !== 'ALL'" (click)="statusDropdown.show()" src="assets/images/filter-filled.svg" />-->
              <p-dropdown
                #statusDropdown
                (onChange)="onChangeAgencyStatusFilter($event)"
                [(ngModel)]="selectedAgencyStatus"
                [autoDisplayFirst]="false"
                [options]="agencyStatusFilterOptions"
              ></p-dropdown>
            </div>
          </div>
        </th>
        <th class="w-8rem" id="rowsSelected">
          <div class="gc-filter-TCOL-right">
            <img
              (click)="selectedAgencyRows.show()"
              alt="vector.svg"
              src="../../../assets/images/vector.svg"
            />
            <p-multiSelect
              #selectedAgencyRows
              (onChange)="onSelectedRowsChange()"
              [(ngModel)]="selectedRows"
              [displaySelectedLabel]="false"
              [filter]="true"
              [options]="visibleRows"
              appendTo="body"
            >
              <ng-template pTemplate="header">
                <span class="cursor-pointer close-icon" (click)="selectedAgencyRows.hide()"><i class="pi pi-times"></i></span></ng-template>
            </p-multiSelect>
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template let-agencies let-rowIndex="rowIndex" pTemplate="body">
      <tr [pSelectableRow]="agencies" class="p-selectable-row">
        <td *ngIf="selectedRows.length !== 0 && (currentUser.currentUserRole == agencyAdminUser
        || currentUser.currentUserRole == iohSuperAdmin
        || currentUser.currentUserRole == iohAdmin
        || currentUser.currentUserRole == companyAdmin)">
          <p-tableCheckbox [value]="agencies" *ngIf=" currentUser.currentUserRole == iohSuperAdmin
        || currentUser.currentUserRole == iohAdmin || currentUser.currentUserRole == companyAdmin || (currentUser?.currentUserRole == agencyAdminUser && agenciesAllowed?.includes(agencies.id))"></p-tableCheckbox>
        </td>
        <td (click)="openEditUserForm(agencies)" *ngIf="isRowVisible('Agency')">
          <span class="p-column-title">Agency</span>
          <div class="flex align-items-center gap-3">
            <!--<div class="gc-agency-img">
                  <img src="{{ agencies.picture}}">
                </div>-->
            <div
              *ngIf="
                agencies.picture !== null && agencies.picture !== '';
                else elseBlock
              "
              class="gc-agency-img"
            >
              <img alt="agency-img" src="{{ agencies.picture }}" />
            </div>
            <ng-template #elseBlock>
              <div class="gc-agency-img">
                <app-avatar
                  [firstName]="agencies.name"
                  [lastName]=""
                ></app-avatar>
              </div>
            </ng-template>
            <div>
              <p class="gc-agency-name">{{ agencies.name }}</p>
              <p class="gc-agency-handle">{{ agencies.id }}</p>
            </div>
          </div>
        </td>
        <td (click)="openEditUserForm(agencies)" *ngIf="isRowVisible('Email')">
          <span class="p-column-title">Email</span>
          <span class="image-text">{{ agencies.email }}</span>
        </td>
        <td (click)="openEditUserForm(agencies)" *ngIf="isRowVisible('Phone')">
          <span class="p-column-title">Phone</span>
          <span class="image-text"
            >{{
              agencies?.phoneNumber?.countryCode &&
              agencies.phoneNumber?.phoneNumber
                ? agencies?.phoneNumber?.countryCode
                : ""
            }}
            {{
              agencies?.phoneNumber?.phoneNumber
                ? agencies?.phoneNumber?.phoneNumber
                : ""
            }}
          </span>
        </td>
        <td (click)="openEditUserForm(agencies)" *ngIf="isRowVisible('Level')">
          <span class="p-column-title">Level</span>
          <span *ngIf="agencies.agencyLevel === 'Gold'" class="image-text"
            ><img alt="badge-gold.svg" src="../../assets/images/badge-gold.svg"
          /></span>
          <span *ngIf="agencies.agencyLevel === 'Silver'" class="image-text"
            ><img
              alt="badge-silver.svg"
              src="../../assets/images/badge-silver.svg"
          /></span>
          <span *ngIf="agencies.agencyLevel === 'Bronze'" class="image-text"
            ><img
              alt="badge-bronze.svg"
              src="../../assets/images/badge-bronze.svg"
          /></span>
        </td>
        <td (click)="openEditUserForm(agencies)" *ngIf="isRowVisible('Status')">
          <span class="p-column-title">Status</span>
          <span
            [style.color]="
              statusEnum[agencies.status]
                ? statusEnum[agencies.status | titlecase]
                : ''
            "
            class="image-text"
            >{{ agencies.status | titlecase }}</span
          >
        </td>
        <td></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="8" style="text-align: center">
          <span>
            <em class="pi pi-exclamation-circle mr-2"></em>
            No Agencies found
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div>
    <p-paginator
      #paginator
      (onPageChange)="paginate($event)"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [rows]="noOfAgenciesPerRow"
      [totalRecords]="totalAgencies"
      styleClass="gc-paginator"
    ></p-paginator>
  </div>
</div>

<p-sidebar
  (onHide)="onSlideBarClose()"
  [(visible)]="display"
  [showCloseIcon]="false"
  [dismissible]="!isSendingAppLinkEmail"
  position="right"
>
  <ng-template pTemplate="header">
    <div class="align-items-center flex justify-content-between w-full">
      <h2 *ngIf="!showEditForm" class="gc-form-heading">Add Agency</h2>
      <h2 *ngIf="showEditForm" class="gc-form-heading">Agency Detail</h2>
      <span
        (click)="!isSendingAppLinkEmail && onSlideBarClose()"
        class="cursor-pointer"
        [class.disabled]="isSendingAppLinkEmail"
        [style.pointer-events]="isSendingAppLinkEmail ? 'none' : null"
      >
        <em class="pi pi-times"></em>
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="content">
    <div class="popup-wrapper">
      <div class="form-container">
        <form *ngIf="addAgencyForm" [formGroup]="addAgencyForm">
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Basic Information</h3>
            </div>
            <div class="sidebar-form">
              <div class="gc-profile-icon mb-0">
                <div class="gc-profile-wrap">
                  <img
                    [src]="
                      addAgencyForm.value?.picture
                        ? addAgencyForm.value?.picture
                        : '../../assets/images/agency-icon-blue.svg'
                    "
                    alt="agency-icon-blue.svg"
                  />
                </div>
                <div class="flex align-items-center gap-4">
                  <p-fileUpload
                    #fileUpload
                    (onSelect)="onSelect($event)"
                    [auto]="true"
                    [chooseIcon]="null"
                    [chooseLabel]="
                      addAgencyForm.value?.picture ? 'Update' : 'Upload Logo'
                    "
                    [class.profile-img-req]="!addAgencyForm.value?.picture"
                    [maxFileSize]="1000000"
                    accept="image/*"
                    mode="basic"
                    name="demo[]"
                    styleClass="change-img-btn"
                  ></p-fileUpload>
                  <p-button
                    (click)="deleteFile()"
                    *ngIf="addAgencyForm.value?.picture"
                    label="Remove"
                    styleClass="button-sm remove-img-btn"
                  ></p-button>
                </div>
              </div>
              <div class="max-img-note">
                The uploaded image should have a maximum width of 350 pixels
              </div>
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Agency Legal Entity<span class="red">*</span></label>
                  <input
                    formControlName="name"
                    id="name"
                    name="name"
                    pInputText
                    placeholder="Agency Legal Entity"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Agency Name<span class="red">*</span></label>
                  <input
                    formControlName="shortName"
                    id="shortName"
                    name="shortName"
                    pInputText
                    placeholder="Agency Name"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div
                  class="col-12 md:col-6 gc-pr-12"
                  formGroupName="phoneNumber"
                >
                  <label>Phone</label>
                  <div class="flex gc-dialCode">
                    <p-dropdown
                      [options]="countries"
                      formControlName="countryCode"
                      optionLabel="dial_code"
                      optionValue="dial_code"
                    >
                      <ng-template let-country pTemplate="selectedItem">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                    </p-dropdown>
                    <p-inputMask
                      formControlName="phoneNumber"
                      mask="999-999-9999"
                      placeholder="(XXX) XXX-XXXX"
                    ></p-inputMask>
                  </div>
                </div>
                <div class="col-12 md:col-6 gc-pl-12" formGroupName="fax">
                  <label>Fax</label>
                  <div class="flex gc-dialCode">
                    <p-dropdown
                      [options]="countries"
                      formControlName="countryCode"
                      optionLabel="dial_code"
                      optionValue="dial_code"
                    >
                      <ng-template let-country pTemplate="selectedItem">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                      <ng-template let-country pTemplate="item">
                        <span
                          class="fi fi-{{
                            country.code.toLowerCase()
                          }} countryflag"
                        ></span>
                        <span class="country-code">
                          {{ country.dial_code }}</span
                        >
                      </ng-template>
                    </p-dropdown>
                    <p-inputMask
                      formControlName="fax"
                      mask="999-999-9999"
                      placeholder="(XXX) XXX-XXXX"
                    ></p-inputMask>
                  </div>
                </div>
              </div>

              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>Email<span class="red">*</span></label>
                  <span class="p-input-icon-left">
                    <span class="gc-input-icon"
                      ><img
                        alt="email-icon.svg"
                        src="../../assets/images/email-icon.svg"
                    /></span>
                    <input
                      formControlName="email"
                      id="email"
                      name="email"
                      pInputText
                      placeholder="Email"
                      type="email"
                    />
                  </span>
                </div>

                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Status</label>
                  <div>
                    <p-dropdown
                      [options]="agencyStatus"
                      formControlName="status"
                      placeholder="Select Status"
                    >
                      <ng-template let-status pTemplate="selectedItem"
                        ><span
                          [style.color]="
                            statusEnum[status.value]
                              ? statusEnum[status.value]
                              : ''
                          "
                          >{{ status.label }}</span
                        ></ng-template
                      >
                    </p-dropdown>
                  </div>
                </div>
              </div>

              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Agency Level</label>

<!--                  <div class="agency-level-preview" *ngIf="addAgencyForm?.get('agencyLevel')?.value as level">-->
<!--                    <img *ngIf="level === 'Gold'" alt="badge-gold.svg" src="../../assets/images/badge-gold.svg" />-->
<!--                    <img *ngIf="level === 'Silver'" alt="badge-silver.svg" src="../../assets/images/badge-silver.svg" />-->
<!--                    <img *ngIf="level === 'Bronze'" alt="badge-bronze.svg" src="../../assets/images/badge-bronze.svg" />-->
<!--                  </div>-->

                  <div class="flex justify-content-between">
                    <p-selectButton
                      [options]="agencyLevel"
                      class="gc-agency-badge"
                      formControlName="agencyLevel"
                    >
                      <ng-template let-item pTemplate="item">
                        <div
                          [ngClass]="[
                            item.value == 'Gold'
                              ? 'btn-gold'
                              : '' || item.value == 'Silver'
                              ? 'btn-silver'
                              : '' || item.value == 'Bronze'
                              ? 'btn-bronze'
                              : ''
                          ]"
                          class="gc-badge-btn"
                        >
                          <span>
                            <img *ngIf="item?.icon" class="agency-level-badge-icon" [alt]="item.value + ' badge'" [src]="item.icon" />
                            {{ item.value }}
                          </span>
                        </div>
                      </ng-template>
                    </p-selectButton>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Associated Company with Agency -->
          <div
            *ngIf="currentUser.is_super_admin || currentUser?.is_IOH_admin"
            class="gc-form-section"
          >
            <div class="gc-form-section-heading">
              <h3>Associated Company</h3>
            </div>
            <div>
              <div class="sidebar-form">
                <div class="grid p-fluid mt-2 gc-add-agency">
                  <div class="w-full flex flex-wrap">
                    <div
                      *ngIf="
                        currentUser?.is_super_admin || currentUser?.is_IOH_admin
                      "
                      class="col-12"
                    >
                      <div class="assing-agncy">
                        <div class="assing-agncy-img">
                          <img
                            *ngIf="
                              getCompanySelectedIcon(
                                addAgencyForm.value?.companyId
                              )
                            "
                            [src]="
                              getCompanySelectedIcon(
                                addAgencyForm.value?.companyId
                              )
                            "
                            alt="company-img"
                          />
                        </div>
                        <div class="assing-agncy-filed">
                          <p-autoComplete
                            (completeMethod)="filterCompanies($event)"
                            (onSelect)="onSelectCompany($event)"
                            [forceSelection]="true"
                            [minLength]="1"
                            [showEmptyMessage]="true"
                            [suggestions]="filteredCompanies"
                            field="label"
                            formControlName="companyId"
                            placeholder="Company"
                          ></p-autoComplete>
                          <img
                            alt="search.svg"
                            src="../../../assets/images/search.svg"
                          />
                          <img
                            (click)="removeCompany()"
                            *ngIf="showRemoveCompany()"
                            alt="Checkbox%20base.svg"
                            src="../../../assets/images/Checkbox%20base.svg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="gc-form-section" formGroupName="portalFeatures">
            <div class="gc-form-section-heading">
              <h3>Portal Features</h3>
            </div>
            <div class="sidebar-form">
              <div
                *ngFor="let feature of portalFeatures"
                class="field-checkbox mb-0"
              >
                <p-checkbox
                  (onChange)="onChangePortalFeatureValue($event, feature.name)"
                  [(ngModel)]="feature.value"
                  [binary]="true"
                  [disabled]="
                    currentAgencyRole?.role == COMPANY_ADMIN ||
                    currentUser.currentUserRole !== iohSuperAdmin &&
                    currentUser.currentUserRole !== iohAdmin"
                  [formControlName]="feature.name"
                  [id]="feature.name"
                  [name]="feature.name"
                  [attr.data-testid]="'portal-feature-checkbox-' + feature.name"
                ></p-checkbox>
                <label
                  [pTooltip]="feature.name === 'eDoc' ? 'IO Doc allows agencies to send important patient documents electronically via email or text. This includes Patient Handbooks, Patient Information Reports (PIR), and other patient-facing documents without needing to print or mail physical copies.' : ''"
                  tooltipPosition="top"
                >{{ feature.label || feature.name }}</label>
              </div>
            </div>
          </div>

          <div class="gc-form-section" *ngIf="isEDocEnabled()">
            <div class="gc-form-section-heading">
              <h3 pTooltip="Patient Handbook (PH) contains the agency's required Start of Care documentation that must be provided to the patient. This typically includes patient rights, responsibilities, agency policies, and other required SOC materials." tooltipPosition="top">Patient Handbook Settings</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Agency Default Patient Handbook Template</label>
                  <div *ngIf="showEDocsDragAndDrop" class="dropzone" fileDragDrop>
                    <div class="text-wrapper">
                      <div class="dropFile-wra">
                        <input
                          (change)="handleEDocsFileUpload($event)"
                          accept="application/pdf"
                          id="eDocsFile"
                          name="eDocsFile"
                          type="file"
                        />
                        <div
                          class="flex flex-column align-items-center justify-content-center gap-4"
                        >
                          <img
                            alt="File upload"
                            src="../../assets/images/fileupload.svg"
                          />
                          <label class="textLink" for="eDocsFile"
                            >Drag and drop file here or <u>Choose file</u></label
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div *ngIf="showEDocsFileInfo" class="fileupload-info">
                    <div class="flex align-items-center gap-3 w-8">
                      <img alt="" src="../../assets/images/Document.svg" />
                      <div class="fileupload-meta">
                        <label class="fileupload-text">{{ eDocsFileName }}</label>
                        <span *ngIf="showEditForm && eDocsFileUploadedAt" class="fileupload-uploaded-at">
                          Uploaded At: {{ eDocsFileUploadedAt }}
                        </span>
                      </div>
                    </div>
                    <div class="flex align-items-center gap-3">
                      <button
                        (click)="deleteEDocsFile()"
                        class="btn-cancel p-button button-sm"
                        [disabled]="isEDocsUploading"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                  <p-progressBar
                    *ngIf="eDocsUploadProgressBar"
                    [value]="eDocsUploadValue"
                    [showValue]="true"
                    class="esco-progressBar"
                  ></p-progressBar>
                </div>
              </div>
              <div class="grid p-fluid ph-settings-attempts-row">
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>Total Attempts: </label>
                  <input
                    formControlName="totalAttempts"
                    id="totalAttempts"
                    name="totalAttempts"
                    pInputText
                    placeholder="Total Attempts"
                    type="number"
                  />
                </div>
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Link Expire Duration: </label>
                  <p-inputNumber
                    formControlName="linkExpireDuration"
                    inputId="mile"
                    placeholder="Link Expire Duration"
                    suffix=" Days"
                  >
                  </p-inputNumber>
                </div>
              </div>

              <div class="template-settings-section">

                <div class="template-group">
                  <div class="template-label-row">
                    <label class="template-field-label">Patient Handbook Email Template</label>
                    <i class="pi pi-info-circle template-info-icon"
                       [pTooltip]="TEMPLATE_INFO.phTemplate.emailExample"
                       tooltipPosition="right"
                       tooltipStyleClass="template-tooltip"></i>
                  </div>
                  <p class="template-description">
                    <i class="pi pi-info-circle template-desc-icon"></i>
                    {{ TEMPLATE_INFO.phTemplate.description }}
                  </p>
                  <div class="grid p-fluid template-field-grid" formGroupName="emailTemplates">
                    <div class="col-12" formGroupName="phTemplate">
                      <div formGroupName="email">
                        <textarea
                          class="template-textarea"
                          formControlName="body"
                          pInputTextarea
                          [autoResize]="false"
                          placeholder="Email Template"
                          rows="4"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="template-sms-block">
                    <div class="grid p-fluid template-field-grid" formGroupName="smsTemplates">
                      <div class="col-12" formGroupName="phTemplate">
                        <label class="template-field-label">Patient Handbook SMS Template</label>
                        <textarea
                          class="template-textarea template-textarea-sms"
                          formControlName="sms"
                          pInputTextarea
                          [autoResize]="false"
                          placeholder="SMS Template"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="template-group">
                  <div class="template-label-row">
                    <label class="template-field-label">Patient Information Report (PIR) Email Template</label>
                    <i class="pi pi-info-circle template-info-icon"
                       [pTooltip]="TEMPLATE_INFO.piTemplate.emailExample"
                       tooltipPosition="right"
                       tooltipStyleClass="template-tooltip"></i>
                  </div>
                  <p class="template-description">
                    <i class="pi pi-info-circle template-desc-icon"></i>
                    {{ TEMPLATE_INFO.piTemplate.description }}
                  </p>
                  <div class="grid p-fluid template-field-grid" formGroupName="emailTemplates">
                    <div class="col-12" formGroupName="piTemplate">
                      <div formGroupName="email">
                        <textarea
                          class="template-textarea"
                          formControlName="body"
                          pInputTextarea
                          [autoResize]="false"
                          placeholder="Email Template"
                          rows="4"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="template-sms-block">
                    <div class="grid p-fluid template-field-grid" formGroupName="smsTemplates">
                      <div class="col-12" formGroupName="piTemplate">
                        <label class="template-field-label">Patient Information Report (PIR) SMS Template</label>
                        <textarea
                          class="template-textarea template-textarea-sms"
                          formControlName="sms"
                          pInputTextarea
                          [autoResize]="false"
                          placeholder="SMS Template"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="template-group">
                  <div class="template-label-row">
                    <label class="template-field-label">Other Documents Email Template</label>
                    <i class="pi pi-info-circle template-info-icon"
                       [pTooltip]="TEMPLATE_INFO.otherTemplate.emailExample"
                       tooltipPosition="right"
                       tooltipStyleClass="template-tooltip"></i>
                  </div>
                  <p class="template-description">
                    <i class="pi pi-info-circle template-desc-icon"></i>
                    {{ TEMPLATE_INFO.otherTemplate.description }}
                  </p>
                  <div class="grid p-fluid template-field-grid" formGroupName="emailTemplates">
                    <div class="col-12" formGroupName="otherTemplate">
                      <div formGroupName="email">
                        <textarea
                          class="template-textarea"
                          formControlName="body"
                          pInputTextarea
                          [autoResize]="false"
                          placeholder="Email Template"
                          rows="4"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="template-sms-block">
                    <div class="grid p-fluid template-field-grid" formGroupName="smsTemplates">
                      <div class="col-12" formGroupName="otherTemplate">
                        <label class="template-field-label">Other Documents SMS Template</label>
                        <textarea
                          class="template-textarea template-textarea-sms"
                          formControlName="sms"
                          pInputTextarea
                          [autoResize]="false"
                          placeholder="SMS Template"
                          rows="2"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="gc-form-section" formGroupName="address">
            <div class="gc-form-section-heading">
              <h3>Address</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Line 1<span class="red">*</span></label>
                  <input
                    formControlName="line1"
                    id="line1"
                    name="line1"
                    pInputText
                    placeholder="Line 1"
                    type="text"
                  />
                </div>
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>Line 2</label>
                  <input
                    formControlName="line2"
                    id="line2"
                    name="line2"
                    pInputText
                    placeholder="Line 2"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>City<span class="red">*</span></label>
                  <input
                    formControlName="city"
                    id="addressCity"
                    name="addressCity"
                    pInputText
                    placeholder="City"
                    type="text"
                  />
                </div>
                <div class="col-12 md:col-6 gc-pr-12">
                  <label>State<span class="red">*</span></label>
                  <input
                    formControlName="state"
                    id="addressState"
                    name="addressState"
                    pInputText
                    placeholder="State"
                    type="text"
                  />
                </div>
              </div>
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pl-12">
                  <label>Zipcode<span class="red">*</span></label>
                  <input
                    formControlName="postalCode"
                    id="postalCode"
                    name="postalCode"
                    pInputText
                    placeholder="Zipcode"
                    type="text"
                  />
                </div>
                <div class="col-12 md:col-6"></div>
              </div>
            </div>
          </div>

          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Agency Settings</h3>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12 md:col-6 gc-pr-12">
                  <p-checkbox
                    [binary]="true"
                    formControlName="isIOHHelp"
                    inputId="binary"
                    label="io Assist"
                    data-testid="agency-settings-isIOHHelp-checkbox"
                  ></p-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="gc-form-section" formGroupName="appSettings">
            <div class="gc-form-section-heading">
              <h3>App Settings</h3>
            </div>
            <div class="sidebar-form app_setting">
<!--              <div>-->
              <div class="grid p-fluid">
                <div class="col-12 md:col-4 gc-pr-12" *ngFor="let app of appSettingCheckboxes; let i=index;">
                  <div *ngIf="app.label !== 'DL Rules' || (currentUser?.is_super_admin || currentUser.is_IOH_admin)">
                    <p-checkbox
                    (onChange)="onChangeAppSettingValue($event, app.value)"
                    [binary]="true"
                    formControlName="{{app.value}}"
                    inputId="binary"
                    label="{{app.label}}"
                    [attr.data-testid]="'app-setting-checkbox-' + app.value"
                  ></p-checkbox>
                  </div>

                </div>
                <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="col-12 md:col-6 gc-pr-10">
                  <label class="mr-2" style="width: 69px">Enable/Disable QA Pre Check</label>
                  <p-dropdown
                    [ngStyle]="{'height': '25px', 'width': '1020px', 'padding': '0 0'}"
                    [options]="registrationTypeFilterOptions"
                    formControlName="disablePreQACheck"
                    placeholder="Enable/Disable QA Pre Check"
                    styleClass="w-full"
                    data-testid="user-settings-disablePreQACheck-dropdown"
                  ></p-dropdown>
                </div>
                <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="col-12 md:col-6 gc-pr-10">
                  <label class="mr-2" style="width: 69px">Enable/Disable Survey Guide</label>
                  <p-dropdown
                    [ngStyle]="{'height': '25px', 'width': '100px', 'padding': '0 0'}"
                    [options]="registrationTypeFilterOptions"
                    formControlName="disableSurveyGuide"
                    placeholder="Enable/Disable Survey Guide"
                    styleClass="w-full"
                    data-testid="user-settings-disableSurveyGuide-dropdown"
                  ></p-dropdown>
                </div>
              </div>

<!--                <div class="col-5 " formGroupName="userSettings">-->
<!--                  <label class="mr-4" style="width: 69px">Enable/Disable QA Pre Check</label>-->
<!--                  <p-dropdown-->
<!--                    [ngStyle]="{'height': '50px', 'width': '162px', 'padding': '0 0'}"-->
<!--                    [options]="registrationTypeFilterOptions"-->
<!--                    formControlName="disablePreQACheck"-->
<!--                    placeholder="Enable/Disable QA Pre Check"-->
<!--                    styleClass="w-full"-->
<!--                    data-testid="user-settings-disablePreQACheck-dropdown"-->
<!--                  ></p-dropdown>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'minBuildVersion')"-->
<!--                    [binary]="true"-->
<!--                    formControlName="minBuildVersion"-->
<!--                    inputId="binary"-->
<!--                    label="Minimum Build Version"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'showOK')"-->
<!--                    [binary]="true"-->
<!--                    formControlName="showOK"-->
<!--                    inputId="binary"-->
<!--                    label="Show OK"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--                <div class="col-12 md:col-6 gc-pl-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="-->
<!--                      onChangeAppSettingValue($event, 'showWarnError')-->
<!--                    "-->
<!--                    [binary]="true"-->
<!--                    formControlName="showWarnError"-->
<!--                    inputId="binary"-->
<!--                    label="Show Warning and Error"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="-->
<!--                      onChangeAppSettingValue($event, 'highlightCircle')-->
<!--                    "-->
<!--                    [binary]="true"-->
<!--                    formControlName="highlightCircle"-->
<!--                    inputId="binary"-->
<!--                    label="Highlight Circle"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--                <div class="col-12 md:col-6 gc-pl-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="-->
<!--                      onChangeAppSettingValue($event, 'highlightSrect')-->
<!--                    "-->
<!--                    [binary]="true"-->
<!--                    formControlName="highlightSrect"-->
<!--                    inputId="binary"-->
<!--                    label="Highlight Small Rectangle"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="-->
<!--                      onChangeAppSettingValue($event, 'highlightLrect')-->
<!--                    "-->
<!--                    [binary]="true"-->
<!--                    formControlName="highlightLrect"-->
<!--                    inputId="binary"-->
<!--                    label="Highlight Large Rectangle"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--                <div class="col-12 md:col-6 gc-pl-12">-->
<!--                  <p-checkbox-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'toastPopUp')"-->
<!--                    [binary]="true"-->
<!--                    formControlName="toastPopUp"-->
<!--                    inputId="binary"-->
<!--                    label="Show Toast Popup"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    [binary]="true"-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'crossRulesEnabled')"-->
<!--                    formControlName="crossRulesEnabled"-->
<!--                    inputId="binary"-->
<!--                    label="Cross Matrix Rules"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--                <div class="col-12 md:col-6 gc-pl-12">-->
<!--                  <p-checkbox-->
<!--                    [binary]="true"-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'crossRulesA2VsA1Enabled')"-->
<!--                    formControlName="crossRulesA2VsA1Enabled"-->
<!--                    inputId="binary"-->
<!--                    label="GG 1 & 2 Rules"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    [binary]="true"-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'dcVsSocRulesEnabled')"-->
<!--                    formControlName="dcVsSocRulesEnabled"-->
<!--                    inputId="binary"-->
<!--                    label="DC vs SOC Rules (including A3 vs A1)"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--                <div class="col-12 md:col-6 gc-pl-12">-->
<!--                  <p-checkbox-->
<!--                    [binary]="true"-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'webCrossRulesEnabled')"-->
<!--                    formControlName="webCrossRulesEnabled"-->
<!--                    inputId="binary"-->
<!--                    label="Web Cross Matrix Rules"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="grid p-fluid">-->
<!--                <div class="col-12 md:col-6 gc-pr-12">-->
<!--                  <p-checkbox-->
<!--                    [binary]="true"-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'webCrossRulesA2VsA1Enabled')"-->
<!--                    formControlName="webCrossRulesA2VsA1Enabled"-->
<!--                    inputId="binary"-->
<!--                    label="Web GG 1 & 2 Rules"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--                <div class="col-12 md:col-6 gc-pl-12">-->
<!--                  <p-checkbox-->
<!--                    [binary]="true"-->
<!--                    (onChange)="onChangeAppSettingValue($event, 'webDcVsSocRulesEnabled')"-->
<!--                    formControlName="webDcVsSocRulesEnabled"-->
<!--                    inputId="binary"-->
<!--                    label="Web DC vs SOC Rules (including A3 vs A1)"-->
<!--                  ></p-checkbox>-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>
          <!--          <div class="gc-form-section">-->
          <!--            <div class="gc-form-section-heading">-->
          <!--              <h3>Enable/Disable Diagnosis Groups</h3>-->
          <!--            </div>-->
          <!--            <div class="sidebar-form">-->
          <!--            <div class="grid p-fluid">-->
          <!--            <div class="col-12 md:col-6 gc-pl-12">-->
          <!--                  <p-checkbox-->
          <!--                    (onChange)="checkDiagnosisGroupVisibility($event)"-->
          <!--                    [binary]="true"-->
          <!--                    name="disableDiagnosisGroups"-->
          <!--                    [(ngModel)]="disableDiagnosisGroups"-->
          <!--                    inputId="binary"-->
          <!--                    label="Show hide Diagnosis Groups"-->
          <!--                  ></p-checkbox>-->
          <!--                </div>-->
          <!--            </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Diagnosis Groups</h3>
            </div>
            <div class="col-12 md:col-6 p-4">
              <p-checkbox
                (onChange)="checkDiagnosisGroupVisibility($event)"
                [binary]="true"
                inputId="binary"
                label="Enable diagnosis group"
                formControlName="disableDiagnosisGroups"
                data-testid="disableDiagnosisGroups-checkbox"
              ></p-checkbox>
            </div>
            <div *ngIf="disableDiagnosisGroups" class="sidebar-form pt-0">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Default Diagnosis Group</label>
                  <p-dropdown
                    [options]="diagnosisGroupOptions"
                    formControlName="defaultDiagnosisGroup"
                    optionLabel="name"
                    optionValue="name"
                    placeholder="Select a Group"
                  ></p-dropdown>
                </div>
              </div>

              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Diagnosis Groups</label>
                  <p-multiSelect
                    [(ngModel)]="selectedDiagnosisGroups"
                    [options]="diagnosisGroupOptions"
                    appendTo="body"
                    display="chip"
                    formControlName="diagnosisGroups"
                    optionLabel="name"
                    placeholder="Select Diagnosis Groups"
                  ></p-multiSelect>
                </div>
              </div>
            </div>
          </div>

          <div class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>User Login with PCID</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12">
                  <div>
                    <p-dropdown  [options]="registrationTypeFilterOptions"
                      formControlName="loginWithPCIDenabled">
                      <ng-template let-registrationType pTemplate="selectedItem"
                        ><span>{{ registrationType.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
          <div *ngIf="currentUser?.is_super_admin || currentUser?.is_IOH_admin" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set NonMDM Customer Settings</h3>
            </div>
              <div class="">
                <div class="col-12 md:col-12 gc-pr-12">
                  <div>
                    <p-dropdown
                    [options]="nonMdmCustomerOptions"
                    formControlName="nonMDMCustomer" placeholder="Select Option">
                    <ng-template let-rotationSet pTemplate="selectedItem"
                      ><span>{{ rotationSet.label }}</span></ng-template>
                  </p-dropdown>
                </div>
              </div>
          </div>
          </div>
          <div *ngIf="showEditForm && isSuperAdminOnlyRole && addAgencyForm?.value?.nonMDMCustomer === NonMDMCustomerEnum.Enabled" class="gc-form-section">
            <div class="gc-form-section-heading">
              <h3>Set App Link</h3>
              <span
                (click)="sendBulkEmail()"
                class="resend-btn cursor-pointer"
                [class.disabled]="isSendingAppLinkEmail"
                [style.pointer-events]="isSendingAppLinkEmail ? 'none' : null"
              >
                Send bulk Email
              </span>
            </div>
            <div class="sidebar-form">
              <div class="grid p-fluid">
                <div class="col-12">
                  <label>Select App Link<span class="red">*</span></label>
                  <p-dropdown
                    [disabled]="isFetchingAppLinks || isSendingAppLinkEmail"
                    [options]="appLinkOptions"
                    [(ngModel)]="selectedAppLinkId"
                    placeholder="Select App Link"
                    [ngModelOptions]="{standalone: true}"
                    [filter]="true"
                    appendTo="body"
                    optionLabel="label"
                    optionValue="value"
                    styleClass="w-full app-link-dropdown"
                  ></p-dropdown>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="gc-slide-footer flex justify-content-end gap-4">
      <button
        (click)="onDeleteClick()"
        *ngIf="showEditForm && currentUser.currentUserRole != agencyAdminUser"
        class="btn-delete"
        label="Delete"
        [disabled]="isSendingAppLinkEmail"
        pButton
      ></button>
      <button
        (click)="onSlideBarClose()"
        class="btn-cancel"
        label="Cancel"
        [disabled]="isSendingAppLinkEmail"
        pButton
        type="submit"
      ></button>
      <button
        (click)="checkIfEmailExists()"
        *ngIf="!showEditForm"
        [disabled]="!addAgencyForm.valid || showInvalidSMSTemplateError"
        label="Add"
        pButton
        type="submit"
      ></button>
      <button
        (click)="onUpdateClick()"
        *ngIf="showEditForm"
        [disabled]="!addAgencyForm.valid || showInvalidSMSTemplateError || isSendingAppLinkEmail"
        label="Update"
        pButton
        type="submit"
      ></button>
    </div>
  </ng-template>
</p-sidebar>
